import { lazy } from "react";

export type { IReportPopupProps } from "./types";

export const ReportPopup = lazy(() => import("./ReportPopup"));
